import { clsx } from "./auth-service-tools193.js";
const EMPTY_CLASS_NAMES = {};

function mergeClassNames(objects) {
  const merged = {};
  objects.forEach(obj => {
    Object.entries(obj).forEach((_ref) => {
      let [key, value] = _ref;

      if (merged[key]) {
        merged[key] = clsx(merged[key], value);
      } else {
        merged[key] = value;
      }
    });
  });
  return merged;
}

function resolveClassNames(_ref2) {
  let {
    theme,
    classNames,
    props,
    stylesCtx
  } = _ref2;
  const arrayClassNames = Array.isArray(classNames) ? classNames : [classNames];
  const resolvedClassNames = arrayClassNames.map(item => typeof item === "function" ? item(theme, props, stylesCtx) : item || EMPTY_CLASS_NAMES);
  return mergeClassNames(resolvedClassNames);
}

export { resolveClassNames };